<template>
    <div class="message-block">
        <h4 class="line mb-3" id="M1">相關留言</h4>
        <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 6}"
                placeholder="輸入留言"
                maxlength="500"
                show-word-limit
                @focus="OpenText"
                v-model="message">
        </el-input>
        <div class="text-right mt-2 mb-2">
            <el-button type="primary" round size="mini" @click="messageConfirm" :disabled="message===''">送出</el-button>
        </div>

        <!--todo 沒有留言狀態-->
        <div class="no-data" v-if="messageList !== null && messageList.length <= 0">
            沒有留言
        </div>

        <div class="list-message" v-for="(item, index) in messageList" :key="index">
            <div class="member-form">
                <el-image :src="item.picture" fit="cover" lazy/>
                <div class="right-block">
                    <span class="name">{{item.userName}}</span>
                    <span class="date2">{{item.createdAt}}</span>
                </div>

                <!--todo 留言者才會有刪除-->
                <div class="mr-2" v-if="item.isSelf">
                    <el-button @click="openDeleteMessageModal('confirm', item)" type="text" size="mini">刪除</el-button>
                </div>
            </div>
            <div class="con">
                {{item.content}}
            </div>
            <div class="mt-3">
                <el-button @click="reply(item)" round size="mini">回覆 {{item.replyCount}}</el-button>
                <el-button @click="OpenReport('confirm', item)" size="mini" type="text" class="ml-3">檢舉</el-button>
            </div>

            <div v-if="item.replyBtn" class="mt-2">
                <!--todo 回覆的留言-->
                <div class="reply-block" v-for="(item1, index1) in item.replyList" :key="index1">
                    <div class="member-form">
                        <el-image :src="item1.picture" fit="cover" lazy/>
                        <div class="right-block">
                            <span class="name">{{item1.userName}}</span>
                            <span class="date2">{{item1.createdAt}}</span>
                        </div>

                        <!--todo 留言者才會有刪除-->
                        <div class="mr-2" v-if="item1.isSelf">
                            <el-button @click="openDeleteMessageModal('reply', item1)" type="text" size="mini">刪除</el-button>
                        </div>
                    </div>
                    <div class="con">
                        {{item1.content}}
                    </div>
                </div>
                <el-input
                        type="textarea"
                        :autosize="{ minRows: 1, maxRows: 6}"
                        placeholder="輸入回覆"
                        maxlength="500"
                        show-word-limit
                        @focus="OpenText"
                        v-model="item.message">
                </el-input>
                <div class="text-right mb-3 mt-2">
                    <el-button type="primary" round size="mini" @click="messageReply(item.id, item.message)"
                               :disabled="item.message===undefined">送出
                    </el-button>
                </div>
            </div>
        </div>

        <!--TODO 檢舉-->
        <CommDialog :value="ReportModal"
                    :outerContent="'請選擇檢舉該留言的理由'"
                    @result="onDialogResult">
                <div class="mt-4 w-75 pl-3 pr-3">
                    <el-radio-group v-model="radioReport">
                        <el-radio :label="1">此為廣告或垃圾訊息</el-radio>
                        <el-radio :label="2">內容冒犯他人或具有威脅性</el-radio>
                        <el-radio :label="3">其他</el-radio>
                    </el-radio-group>
                </div>
        </CommDialog>


        <!--TODO 刪除留言-->
        <CommDialog :value="deleteMessageModal"
                    :outerContent="'刪除留言'"
                    :main-content="'您確定要刪除此筆留言'"
                    @result="onDeleteMessage">
        </CommDialog>

        <comm-dialog class="dialog-dark"
                     :value="LoginModal"
                     :outerContent="'請先登入'"
                     :isModal="false"
                     @result="onCommDialogClose"/>
    </div>
</template>

<script>
    import CommDialog from '@/components/CommDialog.vue';
    export default {
        name: "Message",
        props: {
            messageList: Array,
        },
        components: {
            CommDialog,
        },
        data() {
            return {
                isLogin: this.$auth.isAdminLogin(),
                replyBtn: false,//回覆留言開關
                ReportModal: false,//檢舉留言彈框
                message: '',
                input: '',
                radioReport: 1,
                deleteMessageModal: false,
                LoginModal: false,
                openType: '',
                selectItem: {},
            }
        },
        methods: {
            reply(replyDate) {
                if (replyDate.replyBtn === undefined) {//判斷此物件屬性是否存在
                    this.$set(replyDate, 'replyBtn', true)//若否，則新增屬性並給予預設值
                } else {
                    replyDate.replyBtn = !replyDate.replyBtn
                }
            },
            messageReply(id, message) {
                this.$emit('message-reply', {id: id, message: message});
                message = '';
            },
            messageConfirm() {
                this.$emit('message-confirm', this.message)
                this.message = '';
            },
            onDialogResult(isSure) {
                if(isSure) {
                    let obj = {
                        'selectItem': this.selectItem,
                        'radioReport': this.radioReport
                    }
                    if(this.openType === 'confirm') {
                        this.$emit('messageConfirmReport', obj);
                    }
                    this.ReportModal = false;
                } else {
                    this.ReportModal = false;
                }
            },
            onDeleteMessage(isSure){
                if(isSure) {
                    let obj = {
                        'selectItem': this.selectItem
                    }
                    if(this.openType === 'confirm') {
                        this.$emit('messageConfirmDelete', obj);
                    } else if(this.openType === 'reply') {
                        this.$emit('messageReplyDelete', obj);
                    }
                    this.deleteMessageModal = false;
                } else {
                    this.deleteMessageModal = false;
                }
            },
            onCommDialogClose(result) {
                if (result) {
                    this.$router.push({name: 'Login'});
                } else {
                    this.LoginModal = false
                }
            },
            OpenReport(type, item) {
                if (!this.isLogin) {
                    this.LoginModal = true
                } else {
                    this.openType = type
                    this.selectItem = item
                    this.ReportModal = true
                }
            },
            OpenText(){
                if(!this.isLogin){
                    this.LoginModal = true
                    let focusedElement = document.activeElement;
                    focusedElement.blur();
                }
            },
            openDeleteMessageModal(type, item) {
                this.openType = type
                this.selectItem = item
                this.deleteMessageModal = true
            },
        },
    }
</script>

<style scoped lang="less">
    /deep/.el-textarea {
        .el-input__count {
            bottom: -35px;
            right: 70px;
        }
    }
    .el-radio {
        width: 100%;
        margin: 0 0 15px;
        height: inherit;
    }

    /*留言列表*/
    .list-message {
        margin-bottom: 10px;
        padding-bottom: 10px;
        border-bottom: 1px solid var(--color-gray);
        /*會員狀態*/
        .member-form {
            display: flex;
            margin-bottom: 10px;
            .right-block {
                line-height: 1.2em;
                margin-left: 8px;
                flex: 1;
            }
            .name {
                display: block;
                margin: 5px 0 0;
                font-size: 15px;
                line-height: 15px;
            }
            .el-image{
                height: 40px;
                width: 40px;
                border-radius: 50%;
            }
        }
        .con {
            font-size: 15px;
            line-height: 1.8em;
            //隨編輯器空格換行
            white-space: pre-line;
        }
        /*回饋的區塊*/
        .reply-block {
            margin: 0 0 10px 15px;
            padding: 10px;
            position: relative;
            background: #ffffff;
            border: 1px solid var(--color-gray);
            border-radius: 4px;
        }
        .reply-block:after,
        .reply-block:before {
            right: 100%;
            top: 15%;
            border: solid transparent;
            content: "";
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
        }
        .reply-block:after {
            border-color: rgba(255, 255, 255, 0);
            border-right-color: #ffffff;
            border-width: 8px;
            margin-top: -8px;
        }
        .reply-block:before {
            border-color: rgba(230, 227, 224, 0);
            border-right-color: #ebebeb;
            border-width: 9px;
            margin-top: -9px;
        }
    }
</style>
